// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"7011f46c","769":"433a63d2"}[chunkId] + ".chunk.css";
};